import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import NRTButton from "../../../_common/_buttons/Button"
import ButtonWithChevron from "../../../_minha-central/ButtonWithChevron"


const Slide = ({
                   imgSrc,
                   title,
                   subtitle,
                   actionButton,
                   darkOverlay,
                   lightOverlay,
                   center,

               }) => {


    let overlayBackground = 'none'

    if (darkOverlay)
        overlayBackground = ' rgba(0, 0, 0, .5)'
    else if (lightOverlay)
        overlayBackground = ' rgba(255, 255, 255, .3)'

    const centerCls = center ? 'center' : 'left'

    return (
        <div className={"nrt-slide ms-slide " + centerCls} data-delay="5">


            <img src={imgSrc} data-src={imgSrc}/>

            <div className='slide-content'
                 style={{
                     background: overlayBackground,
                     alignItems: center ? 'center' : 'left',
                     paddingLeft: center ? 0 : '5rem',
                 }}>


                    {
                        !!title &&
                        <h3>{title}</h3>
                    }
                    {
                        !!subtitle &&
                        <h4 className={ darkOverlay ? 'dark-overlay' : 'light-overlay' }
                            style={{
                                textAlign: center ? 'center' : 'left',
                            }}
                        >

                            {subtitle}</h4>
                    }
                    {
                        !!actionButton.link &&
                        <ButtonWithChevron onClick={() => window.location.replace(actionButton.link)}
                                           buttonLabel={actionButton.title}
                                           actionButton/>
                    }




            </div>


        </div>
    )
}

Slide.propTypes = {
    imgSrc: PropTypes.string.isRequired,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    actionButton: PropTypes.object,
    darkOverlay: PropTypes.bool,
    lightOverlay: PropTypes.bool,
    center: PropTypes.any,
}

Slide.defaultProps = {
    position: 'left',
    darkOverlay: false,
    lightOverlay: false,
    center: false,
}

export default Slide






// WEBPACK FOOTER //
// ./src/components/_home/Slider/Slide/index.js